import { ApplicationQuestionsData } from '@hooks/jobsBoard/useApplyToApplicationJob';
import { useGetUserAppearance } from '@hooks/shared/useGetUserAppearance';

import { JobsBoardWardrobeQuestion } from './JobsBoardWardrobeQuestion/JobsBoardWardrobeQuestion';
import { AttachmentQuestion } from './AttachmentQuestion';
import { JobQuestion } from './JobQuestion';
import { StyledForm, StyledLoadingSpinner } from './styles';

type SubmitJobQuestionsProps = {
  loggedInUserId: number;
  publicApplicationData: PublicApplication;
  applicationQuestionsData: ApplicationQuestionsData;
};
export const SubmitJobQuestions = ({
  loggedInUserId,
  publicApplicationData,
  applicationQuestionsData,
}: SubmitJobQuestionsProps) => {
  const {
    data: userAppearance,
    isError,
    isLoading,
  } = useGetUserAppearance(loggedInUserId);

  if (isLoading) {
    return <StyledLoadingSpinner />;
  }

  if (isError || !userAppearance || !publicApplicationData) {
    return <div>Something went wrong</div>;
  }

  return (
    <SubmitJobQuestionsContent
      applicationQuestionsData={applicationQuestionsData}
      userAppearance={userAppearance}
      projectLocationCountry={
        publicApplicationData?.project_detail?.project_country || 'US'
      }
    />
  );
};

type SubmitJobQuestionsContentProps = {
  applicationQuestionsData: ApplicationQuestionsData;
  userAppearance: UserAppearance;
  projectLocationCountry: ProductionCountry;
};
const SubmitJobQuestionsContent = ({
  applicationQuestionsData,
  userAppearance,
  projectLocationCountry,
}: SubmitJobQuestionsContentProps) => {
  const {
    questions,
    formInstance,
    attachmentQuestions,
    handleFileUpload,
    columnIdToFileIdsLoading,
    columnIdToAttachmentUrls,
    onFileRemove,
    getAttachmentQuestionErrorMessage,
    wasSubmitButtonClicked,
    mappedWardrobe,
  } = applicationQuestionsData;

  return (
    <StyledForm
      form={formInstance}
      onFinish={applicationQuestionsData.onSubmitForm}
    >
      {!!questions?.length &&
        questions?.map((question) => (
          <JobQuestion
            question={question}
            key={`job-question-${question?.listColumnId}`}
          />
        ))}

      {!!attachmentQuestions?.length &&
        attachmentQuestions?.map((question) => (
          <AttachmentQuestion
            key={`attachment-question-${question.listColumnId}`}
            question={question}
            handleFileUpload={handleFileUpload}
            fileIdsLoading={columnIdToFileIdsLoading?.[question?.listColumnId]}
            attachmentUrls={
              columnIdToAttachmentUrls?.[question?.listColumnId] || []
            }
            onFileRemove={onFileRemove}
            getAttachmentQuestionErrorMessage={
              getAttachmentQuestionErrorMessage
            }
            wasSubmitButtonClicked={wasSubmitButtonClicked}
          />
        ))}

      {!!mappedWardrobe?.length &&
        mappedWardrobe?.map((wardrobeItem) => (
          <JobsBoardWardrobeQuestion
            key={`wardrobe-question-${wardrobeItem?.profileField}`}
            wardrobeItem={wardrobeItem}
            userAppearance={userAppearance}
            projectLocationCountry={projectLocationCountry}
          />
        ))}
    </StyledForm>
  );
};
